<template>
  <VDialog v-model="dialog" width="500">
    <VCard>
      <VCardTitle>
        {{ $t("acts") }}
        <VSpacer />
        <VBtn fab text small @click="dialog = false">
          <VIcon size="20">mdi-close</VIcon>
        </VBtn>
      </VCardTitle>
      <VCardText>
        <span v-if="!files.length">{{ $t("noDataAvailable") }}</span>
        <VSheet
          :key="`file-${index}`"
          v-for="(item, index) in files"
          color="primary"
          class="px-2 mb-1"
          rounded
          dark
        >
          <span>{{ item.aktFileName }}</span>
          <Downloader
            btn-class="w"
            :address="item.aktFileLink"
            :file-name="item.aktFileName"
          />
          <VBtn
            v-if="hasAccessUploadFile"
            @click="onDelete(item)"
            class="new_style"
          >
            <VueIcon icon="newTrashIcon" />
          </VBtn>
        </VSheet>
        <VBtn
          v-if="hasAccessUploadFile"
          :loading="loading"
          @click="browseFile"
          width="100%"
          class="new_style"
        >
          <VueIcon icon="newPlusIcon"></VueIcon>
        </VBtn>
      </VCardText>
      <input
        v-if="hasAccessUploadFile"
        @change="uploadFile"
        ref="fileInput"
        type="file"
        class="d-none"
      />
    </VCard>
    <WarningDialog
      @apply="deleteFile"
      v-model="warningDialog"
      ref="warningDialog"
    ></WarningDialog>
  </VDialog>
</template>

<script>
import Downloader from "@/components/ui/downloader";
import WarningDialog from "@/components/ui/prompt/warning-dialog.vue";

export default {
  name: "OrderItemActFilesDialog",
  props: {
    hasAccessUploadFile: {
      type: Boolean,
      default: false,
    },
  },
  components: { WarningDialog, Downloader },
  data() {
    return {
      warningDialog: false,
      dialog: false,
      /**
       * @type Array<{aktFileName, aktFileLink}>
       */
      files: [],
      orderItemId: null,
      loading: false,
    };
  },
  methods: {
    async deleteFile(item) {
      this.showLoading();
      try {
        await this.$http.post("contract/remove-akt-file", item);
        this.setSuccess({ text: this.$t("successfullyDeleted") });
        await this.open(this.orderItemId);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    onDelete(item) {
      this.$refs.warningDialog.open({
        orderItemId: this.orderItemId,
        aktFileId: item.aktFileId,
      });
    },
    async open(orderItemId) {
      this.dialog = true;
      this.orderItemId = orderItemId;
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get("contract/item/akt-files", {
          params: { orderItemId },
        });
        this.files = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    browseFile() {
      const { fileInput } = this.$refs;
      fileInput.click();
    },
    async uploadFile(e) {
      const formData = new FormData();
      formData.append("orderItemIds", this.orderItemId);
      formData.append("file", e.target.files[0]);
      try {
        this.loading = true;
        const {
          data: { data },
        } = await this.$http.post("contract/attach-akt-file", formData);
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.files.push(data);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
        this.clearFileInput();
      }
    },
    clearFileInput() {
      const { fileInput } = this.$refs;
      if (fileInput) {
        fileInput.setAttribute("type", "text");
        fileInput.setAttribute("type", "file");
      }
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.orderItemId = null;
        this.files = [];
        this.loading = false;
        this.clearFileInput();
      }
    },
  },
};
</script>
